var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 627.57391,
    height: 1141.9291,
    viewBox: "0 0 627.57391 1141.9291",
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    id: "svg4665",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4669"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dry",
    transform: "matrix(0.829192,0,0,1.09268,-530.14939,-1679.2909)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.898487,0,0,0.908155,-13.4083,192.056)",
    id: "g4526"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.601275,0,0,0.456284,-672.63,-481.34)",
    id: "g4492"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3000.29,
    cy: 4971.0898,
    r: 277.556,
    id: "circle4490"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.82989,0,0,0.915179,-1236.33,-3209.8)",
    id: "g4496"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2853.02,5125.34 76.57,180.98 h -153.14 z",
    id: "path4494"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.82989,0,0,-0.915179,3499.07,6779.33)",
    id: "g4500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2853.02,5125.34 76.57,180.98 h -153.14 z",
    id: "path4498"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,0.623066,-1.21897,0,7783.86,7.14049)",
    id: "g4504"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2853.02,5125.34 76.57,180.98 h -153.14 z",
    id: "path4502"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-0.623066,1.21897,0,-5521.12,3562.39)",
    id: "g4508"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2853.02,5125.34 76.57,180.98 h -153.14 z",
    id: "path4506"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.586821,-0.440574,0.861942,0.64713,-5246.87,-489.958)",
    id: "g4512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2853.02,5125.34 76.57,180.98 h -153.14 z",
    id: "path4510"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.586821,0.440574,-0.861942,-0.64713,7509.6,4059.48)",
    id: "g4516"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2853.02,5125.34 76.57,180.98 h -153.14 z",
    id: "path4514"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.586821,0.440574,-0.861942,0.64713,4161.17,-3003.9)",
    id: "g4520"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2853.02,5125.34 76.57,180.98 h -153.14 z",
    id: "path4518"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.586821,-0.440574,0.861942,-0.64713,-1898.44,6573.42)",
    id: "g4524"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2853.02,5125.34 76.57,180.98 h -153.14 z",
    id: "path4522"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4530"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 791.429,866.083 82.309,-1.834 -39.057,21.232 -13.631,-3.67 c 0,0 -10.223,41.1 -1.311,47.942 8.913,6.843 12.034,82.077 12.034,82.077 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4528"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4534"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 826.21,617.661 c -18.337,1.019 -36.393,5.628 -20.635,18.009 15.758,12.381 39.741,6.003 54.012,11.631 14.272,5.628 46.538,24.762 44.662,36.393 -1.876,11.631 27.074,4.502 22.541,-9.755 -4.532,-14.257 -33.046,-60.029 -100.58,-56.278 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4532"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.14383,0,0,1.96336,-2017.72,-8958.85)",
    id: "g4538"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2327.24,
    y: 5832.0498,
    width: 657.40503,
    height: 46.025002,
    id: "rect4536"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.03292,-0.0656215,0.0512526,0.914353,-4576.41,-2563.47)",
    id: "g4542"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2543.71,5299.78 c -46.18,185.39 38.88,256.65 -31.81,379.39 9.88,-117.9 -71.88,-163.77 31.81,-379.39 z",
    id: "path4540"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.03292,-0.0656215,0.0512526,0.914353,-4406.65,-2563.47)",
    id: "g4546"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2543.71,5299.78 c -46.18,185.39 38.88,256.65 -31.81,379.39 9.88,-117.9 -71.88,-163.77 31.81,-379.39 z",
    id: "path4544"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.03292,-0.0656215,0.0512526,0.914353,-4242.96,-2563.47)",
    id: "g4550"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2543.71,5299.78 c -46.18,185.39 38.88,256.65 -31.81,379.39 9.88,-117.9 -71.88,-163.77 31.81,-379.39 z",
    id: "path4548"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4554"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 940.47,1321.33 c 0,0 31.072,79.97 24.165,95.21 -6.907,15.23 57.105,-41.35 11.579,-187.35 8.055,62.94 8.055,133.29 2.518,120.77 -5.538,-12.52 -14.6,-7.49 -14.6,-7.49 l 8.055,24.17 c 0,0 -12.586,-3.13 -31.717,-45.31 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path4552"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4558"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 693.532,1101.5 c 0,0 -28.269,99.81 -19.038,114.24 9.231,14.42 41.539,84.23 38.077,100.38 -9.231,-91.15 -32.885,-147.69 -19.039,-214.62 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4556"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4562"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 851.226,1073.23 c 0,0 -55.931,91.17 -37.692,131.54 18.239,40.38 32.42,36.16 32.42,58.08 0,-35.19 -26.233,-140.19 5.272,-189.62 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path4560"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-11.3272,1184.2)",
    id: "g4566"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 937.292,1168.04 c 0,0 14.277,-36.48 30.523,40.77 2.462,-69.03 -8.081,-79.98 4.911,-137.72 -6.892,-2.46 -43.311,85.27 -35.434,96.95 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4564"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4570"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 845.954,1262.85 c 0,0 28.629,79.87 -15.402,153.69 33.839,-103.08 12.523,-156.19 0,-166.55 -12.522,-10.35 15.402,12.86 15.402,12.86 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4568"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4574"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 646.361,1279.15 c 0,0 12.898,47.38 19.589,52.78 6.691,5.41 27.655,72.19 21.894,84.61 -5.762,12.4 39.196,-41.77 32.091,-69.13 -7.106,-27.36 -11.056,51.15 -19.128,29.11 -8.072,-22.04 -46.38,-60.5 -54.446,-97.37 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path4572"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4578"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 790.818,1279.15 c 0,0 3.457,37.45 14.596,47.82 11.139,10.37 27.049,73.92 21.908,91.38 -5.142,17.47 19.219,-64.55 0,-86.42 -19.219,-21.86 -33.047,-31.47 -36.504,-52.78 z",
    style: {
      fill: "#ffffff",
      stroke: "#000000",
      strokeWidth: 1
    },
    id: "path4576"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4582"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 703.456,1084.27 c 0,0 -82.211,109.99 -54.057,207.59",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "1.67px"
    },
    id: "path4580"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4586"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1106.82,1480.74 35.05,0.52 -3.14,24.06 c 0,0 1.05,-17.26 -31.91,-24.58 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4584"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4590"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 547.639,1503.59 4.317,48.22 590.794,3.77",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "6.06px"
    },
    id: "path4588"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10359,0,0,0.915179,85.5605,1144.63)",
    id: "g4594"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 723.823,738.489 c 0,0 12.932,93.43 107.95,89.996 95.017,-3.435 100.866,-65.114 107.077,-83.813 6.212,-18.699 -162.129,107.17 -215.027,-6.183",
    style: {
      fill: "#ffffff"
    },
    id: "path4592"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4598"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 718.74,703.59 c 0,0 -9.103,73.243 34.807,107.353 32.293,25.086 74.222,42.077 145.719,11.3",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path4596"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4602"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 770.638,639.83 c 0,0 -16.099,7.17 -11.342,13.648 4.756,6.477 15.001,9.404 15.001,9.404 l 11.343,-16.1 c 0,0 -12.075,-9.147 -15.002,-6.952 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4600"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 834.842,437.944 c 0,0 9.936,64.8 6.867,72.643 -3.07,7.842 -29.206,45.106 -19.571,50.006 9.635,4.9 19.23,18.541 19.23,18.541 l -49.451,2.388 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4604"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4610"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 719.897,571.856 -94.408,-54.929 75.526,136.551 c 0,0 -20.312,-44.268 -10.299,-48.722 10.013,-4.455 -14.971,-33.652 -14.971,-33.652 0,0 26.701,-2.395 44.152,0.752 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4608"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4614"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 690.225,682.443 c 0,0 10.546,27.733 -14.062,32.81 -24.608,5.078 -18.15,-13.844 -50.674,-1.562 -32.524,12.282 -56.741,12.282 -56.741,12.282 l 48.435,17.013 -72.262,-17.013 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4612"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4618"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1037.96,516.927 c 0,0 -22.19,37.529 -41.247,46.591 -19.062,9.062 -62.809,19.998 -60.622,32.81 2.188,12.812 -0.937,24.999 -0.937,24.999 l -31.873,-24.686 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4616"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4622"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 719.897,837.013 c 0,-5.006 42.354,14.632 42.354,14.632 l -59.9,-57.637 -16.895,34.814 2.816,6.655 -6.144,3.072 c 0,0 -56.639,94.203 -56.639,91.131 0,-3.072 66.983,-59.389 66.983,-59.389 0,0 -8.6,-13.095 0,-15.871 8.599,-2.775 27.425,-10.239 27.425,-17.407 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4620"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4626"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 991.982,847.521 c 0,0 -41.136,-8.4 -37.509,-1.91 3.626,6.49 28.672,51.308 28.672,51.308 l -45.181,-37.182 -13.354,2.561 c 0,0 -24.136,-7.524 -21.329,-9.814 2.807,-2.291 58.352,-58.476 58.352,-58.476 z",
    style: {
      fill: "#ffffff"
    },
    id: "path4624"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4630"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 974.115,764.918 21.635,-41.052 -3.768,-17.086 12.028,12.39 c 0,0 68.22,-4.905 98.8,4.696 30.58,9.6 18.11,0 18.11,0 L 975.1,682.635 Z",
    style: {
      fill: "#ffffff"
    },
    id: "path4628"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4634"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 720.781,577.198 32.857,16.591 -46.196,48.473",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path4632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4638"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 687.923,720.339 -0.976,37.411 -60.184,-14.964",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path4636"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4642"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 843.751,484.807 23.098,92.391 h -7.262",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path4640"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4646"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 947.518,625.996 13.023,19.519 48.469,-82.956",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path4644"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4650"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 983.314,757.75 44.896,-12.036 62.13,-14.314",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path4648"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4654"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 992.423,852.744 32.527,63.437 -21.79,-10.085",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path4652"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4658"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 638.492,922.248 113.263,-66.625 -13.991,-7.995",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path4656"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g4662"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 848.029,884.938 18.82,-8.995 -31.479,112.264",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "4.17px"
    },
    id: "path4660"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDry);
export default __webpack_public_path__ + "static/media/dry.fa3b387256d039da48d6ce689639ad76.svg";
export { ForwardRef as ReactComponent };